import type {
  BILLING_ACCOUNT_STATUS,
  BILLING_MODEL,
  BILLING_PROCESSOR,
  PAYMENT_METHOD,
  PRICING_PLAN_NAME,
} from '../types/billing-account';

export enum BILLING_API_BILLING_MODEL {
  PAY_AS_YOU_GO = 'payg',
  PREPAID_CONSUMPTION = 'prepaidconsumption',
}

export enum BILLING_API_BILLING_PROCESSOR {
  DIRECT = 'direct',
  AZURE_MARKETPLACE = 'azuremarketplace',
  GCP_MARKETPLACE = 'gcpmarketplace',
  AWS_MARKETPLACE = 'awsmarketplace',
}

export enum BILLING_API_PAYMENT_METHOD {
  CREDIT_CARD = 'creditcard',
  MARKETPLACE = 'marketplace',
  BALANCE = 'balance',
}

export enum BILLING_API_BILLING_ACCOUNT_STATUS {
  CREATED = 'created',
  ACTIVATED = 'activated',
  ACTIVE_IN_USE = 'activeinuse',
  SUSPENDED = 'suspended',
  DEACTIVATED = 'deactivated',
}

export enum BILLING_API_PRICING_PLAN_NAME {
  PAY_AS_YOU_GO = 'payg',
  LEGACY_ENTERPRISE = 'vdc_1.0',
  VDC = 'vdc_2.0',
  NON_BILLABLE = 'non-billable',
  NON_PAID = 'non-paid',
}

export interface BillingAccountResponse {
  billing_account_id: string;
  organization_id: string;
  project_ids: string[];
  billing_model: BILLING_MODEL | BILLING_API_BILLING_MODEL;
  billing_processor: BILLING_PROCESSOR | BILLING_API_BILLING_PROCESSOR;
  payment_method: PAYMENT_METHOD | BILLING_API_PAYMENT_METHOD;
  pricing_plan: PRICING_PLAN_NAME | BILLING_API_PRICING_PLAN_NAME;
  status: BILLING_ACCOUNT_STATUS | BILLING_API_BILLING_ACCOUNT_STATUS;
  reason: string;
  email: string;
  name: string;
  is_funded: boolean;
}
